export default {
  LOAD_STUDENT_COMPETENCY_SUBCOMPETENCY_LIST_START: 'LoadStudentCompetencySubcompetencyListStart',
  LOAD_STUDENT_COMPETENCY_SUBCOMPETENCY_LIST_END: 'LoadStudentCompetencySubcompetencyListEnd'
};